<template>
  <div class="card card-body rounded-top">
    <component-table
      entityType="club"
      class="mt-3"
      :columns="columns"
      :actions="actions"
      :data="list"
      :total="count"
      :hide-add-button="true"
      :hideSearchInput="true"
      @delete="showDeleteDialog($event.id)"
      @accept="showEditModal($event.id)"
    />

    <accept-modal :show="showModal" :id="idToEdit" @close="hideModal" @update="accept" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import AcceptModal from '@/components/modals/OfferAcceptModal';
import ComponentTable from '@/components/table/Table';
import TeamModal from '@/components/modals/TeamModal';
import { listMixin } from '@/mixins/list';
import { DELETE_ACTION, ACCEPT_ACTION } from '@/utils/constants';
import { OfferTypeListTranslation, OfferType } from '@/enums/offerType.enum';
import previewModalMixin from '@/mixins/previewModal.mixin';

// @vuese
// Lista Wniosków
// @group Sport
export default {
  mixins: [
    listMixin('club/offers', {
      listError: 'messages.offer.listError',
      getError: 'messages.offer.getError',
      added: 'messages.offer.added',
      addError: 'messages.offer.addError',
      updated: 'messages.offer.updated',
      updateError: 'messages.offer.updateError',
      deleteConfirm: 'messages.offer.deleteConfirm',
      deleted: 'messages.offer.deleted',
      deleteError: 'messages.offer.deleteError'
    }),
    previewModalMixin
  ],
  components: { ComponentTable, AcceptModal },

  data() {
    return {
      columns: [
        { name: 'name', displayName: 'columns.firstAndLastName' },
        { name: 'type', displayName: 'columns.type' }
      ],
      actions: [
        {
          ...ACCEPT_ACTION,
          permissions: ['OFFER.ACCEPT'],
          entityId: this.$route.params.clubId
        },
        { ...DELETE_ACTION, permissions: ['OFFER.DELETE'], entityId: this.$route.params.clubId }
      ]
    };
  },
  computed: {
    ...mapState({
      list: state =>
        state.club.offers.list.map(item => ({
          ...item,
          name: item.profile.firstName + ' ' + item.profile.lastName,
          type: OfferTypeListTranslation[OfferType[item.type]],
          content: item.content
        })),
      count: state => state.club.offers.count
    })
  },

  methods: {
    accept(model) {
      this.$store
        .dispatch('club/offers/accept', { id: model.id, teamIds: model.teamIds })
        .then(() => this.notifySuccess('messages.offer.accept'))
        .catch(() => this.notifyError('messages.offer.acceptError'));
    }
  }
};
</script>
